import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { Search as SearchIcon } from "lucide-react";
import { Input } from "@/components/ui/input";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const runSearch = (query) => {
    if (!query || query.length < 2) return;
    setLoading(true);
    api.get("/search", { params: { q: query } }).then((r) => setItems(r.data))
      .catch(() => setItems([])).finally(() => setLoading(false));
  };
  useEffect(() => { runSearch(params.get("q") || ""); }, [params]);

  return (
    <>
      <PublicHeader />
      <main className="max-w-5xl mx-auto px-4 py-10" data-testid="search-page">
        <form onSubmit={(e) => { e.preventDefault(); setParams({ q }); }} className="flex gap-2 mb-8">
          <div className="relative flex-1">
            <SearchIcon className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"/>
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="ख़बर, विषय, टैग खोजें…"
              className="pl-9 h-11 text-base" data-testid="search-input" autoFocus/>
          </div>
          <button className="bg-[#0F172A] text-white font-bold px-6 rounded-md hover:bg-[#1E3A8A]" data-testid="search-submit">खोजें</button>
        </form>
        {loading ? <div className="text-slate-500">खोज रहे हैं…</div> :
          items.length === 0 && params.get("q") ? <div className="text-slate-500 italic">कोई परिणाम नहीं मिला</div> :
          <div className="space-y-4">
            <div className="text-sm text-slate-500">{items.length} परिणाम "<b>{params.get("q")}</b>" के लिए</div>
            {items.map((n) => (
              <Link key={n.id} to={`/article/${n.slug}`} className="block bg-white border border-slate-100 rounded-lg p-4 hover:shadow-md transition" data-testid={`result-${n.id}`}>
                <div className="flex gap-4">
                  {n.image_url && <img src={n.image_url} alt="" className="w-24 h-24 rounded object-cover shrink-0"/>}
                  <div className="flex-1 min-w-0">
                    <div className="text-[10px] uppercase tracking-widest text-[#EA580C] font-bold">{n.category}</div>
                    <h3 className="font-devnagri-heading font-black text-lg text-[#0F172A] hover:text-[#DC2626]">{n.title}</h3>
                    <p className="text-sm text-slate-600 line-clamp-2">{n.excerpt}</p>
                    <div className="text-[10px] text-slate-400 mt-1">{new Date(n.created_at).toLocaleDateString("hi-IN")} · {n.views || 0} views</div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        }
      </main>
      <PublicFooter />
    </>
  );
}
